<script>

    import DetailsCard from '../$components/details.card.svelte'
    import DetailsFields from '../$components/details.fields.svelte'
    import DetailsField from '../$components/details.field.svelte'

    export let orderLocation = null
    export let subtitle = ''

</script>

{#if orderLocation}

    <div class="subtitle is-5">{ subtitle }</div>

    <DetailsCard>
        <DetailsFields>
            <DetailsField label="Contacto" value={orderLocation.contact} />
            <DetailsField label="RFC" value={orderLocation.rfc || 'Sin información'} />
            <DetailsField label="Corporación" value={orderLocation.corporate || 'Sin información'} />
            <DetailsField label="Correo" value={orderLocation.email} mono />
            <DetailsField label="Teléfono" value={orderLocation.phone} />
            <DetailsField label="Código postal" value={orderLocation.zipcode} />
            <DetailsField label="Estado" value={orderLocation.state} />
            <DetailsField label="Ciudad" value={orderLocation.city} />
            <DetailsField label="Municipio" value={orderLocation.municipality || 'Sin información'} />
            <DetailsField label="Colonia" value={orderLocation.colony} />
            <DetailsField label="Calle" value={orderLocation.street} />
            <DetailsField label="Exterior" value={orderLocation.number} />
            <DetailsField label="Apartamento" value={orderLocation.apartment} />
            <DetailsField label="Referencias" value={orderLocation.references || 'Sin información'} />
            <DetailsField label="Referencias del cliente" value={orderLocation.referencesClient || 'Sin información'} />
        </DetailsFields>
    </DetailsCard>
{/if}
